/* eslint-disable jsx-a11y/alt-text */
//import own components
import LoadingGif from  '../../../images/LoadingGif.gif';
import  './ExpenseDetails.css';

//imports react
import React, {
     useEffect,
} from 'react';
import { useParams } from 'react-router-dom';

//imports firebase
import {collection, doc, getDoc, getDocs, getFirestore} from 'firebase/firestore'
import { getStorage, ref, getDownloadURL } from "firebase/storage";

const db = getFirestore();
const storage = getStorage();

const ExpeseDetails = (props) => {

    const [historyExpense, setHistoryExpense] = React.useState([]);

    const {expenseId} = useParams();
    const {groupId} = useParams();

    useEffect(() => {
       document.title = "Expense Details";
       loadExpensePhoto(); 

       
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return(
        <div style={{minHeight: '100vh'}}>
            <div >
                <h1 className='header'>Expenses Details</h1>
                <p className='errorMessage'></p>
               <div className='detailTopContainer'>
                    <div className="detailContainer">
                        <div className="detailName detailItem">
                            <h2>Name</h2>
                            <p className='detailNameValue detailValue'></p>
                        </div>
                        <div className="detailDate detailItem">
                            <h2>Date</h2>
                            <p className='detailDateValue detailValue'></p>
                        </div>
                        <div className="detailPrice detailItem">
                            <h2>Price</h2>
                            <p className=''>&euro;<span className='detailPriceValue detailValue'></span></p>
                        </div>
                        
                        <div className="detailCategory detailItem">
                            <h2>Category</h2>
                            <p className='detailCategoryValue detailValue'></p>
                        </div>
                        <div className="detailHistory ">
                            <h2>History</h2>
                            <div className='detailHistoryValue detailValue'>
                                {
                                    historyExpense.map((item, index) => {
                                        return(
                                            <div key={index} className='historyItem' style={{margin:'0.5rem', border:'1px lightslategray solid', borderRadius:'0.45rem', padding:'0.5rem'}}>
                                                <p>Updated on: {item.date}</p>
                                                <p>Name: {item.name}</p>
                                                <p>Price: &euro;{item.price}</p>
                                                <p>Category: {item.category}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
               </div>
                <div className="detailPhoto">
                    <h2>Photo</h2>
                    <p style={{margin:'0.3rem', fontSize:'20px', color:'lightslategray'}} className='photoInfo'></p>
                    <img src={LoadingGif} className='loadingGif' alt="Loading" />
                    <img style={{ maxWidth: '70%'}} className='detailPhotoValue expenseImg' id='expenseImg'></img>
                </div>
            </div>
            <div>
                <button onClick={back} className='btn-secondary'>Back</button>
            </div>
        </div>
    )

    function back() {
        window.history.back();
        
    }

    async function loadExpensePhoto() {


        const errorMessage = document.getElementsByClassName('errorMessage')[0];


       try {
           const q = doc(db, "/Groups", groupId, "/Expenses", expenseId);
           const docSnap = await getDoc(q);
           if (docSnap.exists()) {
               const storageRef = ref(storage, `/expensesPhoto/${expenseId}`);
               getDownloadURL(storageRef)
                   .then(function (url) {
                       const img = document.getElementById('expenseImg');
                       img.setAttribute('src', url);
                       document.getElementsByClassName('loadingGif')[0].style.display = 'none';
                   })
                   .catch(function (error) {
                       if (error.code === "storage/object-not-found") {
                           document.querySelector('.photoInfo').innerHTML = "No photo";
                           document.getElementsByClassName('loadingGif')[0].style.display = 'none';

                       }
                       else {
                           document.getElementsByClassName('errorMessage')[0].innerHTML = error.message;
                           document.getElementsByClassName('loadingGif')[0].style.display = 'none';

                       }
                   });

               document.getElementsByClassName('detailNameValue')[0].innerHTML = docSnap.data().name;
               document.getElementsByClassName('detailDateValue')[0].innerHTML = new Date(docSnap.data().date.seconds * 1000).toLocaleDateString();;
               document.getElementsByClassName('detailPriceValue')[0].innerHTML = docSnap.data().price;
               document.getElementsByClassName('detailCategoryValue')[0].innerHTML = docSnap.data().category;



           }
           //laden van de history apart in const steken en mappen in ui.
           else {
               document.getElementsByClassName('errorMessage')[0].innerHTML = 'No expense found';
               return;
           }
           try {
               const historyArray = [];
               const qGHistory = collection(db, "/Groups", groupId, "/Expenses", expenseId, "/History");
               const historySnap = await getDocs(qGHistory);
               historySnap.forEach(doc => {
                   historyArray.push({ id: doc.data().id, name: doc.data().name, date: new Date(doc.data().date.seconds * 1000).toDateString(), price: doc.data().price, category: doc.data().category });
               })
               setHistoryExpense(historyArray);
           } catch (error) {
               errorMessage.innerHTML = error.message;
           }
       } catch (error) {
           errorMessage.innerHTML = "Something went wrong while loading the expense: " + error.message;
       }
    }
}

export default ExpeseDetails;